module.exports = require("./gsw-FR");